import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { HomeActions } from 'src/app/store';
import { SearchClient } from 'src/app/web-api-client';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
    constructor(private store: Store, private searchClient: SearchClient) {
        store.dispatch(HomeActions.loadNews({}));
    }

    async ngOnInit() {
        this.searchClient.getHomePageData().subscribe((data) => {
            this.store.dispatch(HomeActions.updateHomePageStatistics({ statisticsData: data }));
        });
    }
}
